<template>
  <div>
    <Loader :visible="loading" />

    <div class="container mt-4">
      <div class="row mb-4">
        <h2>{{ $t("dashboard.title") }}</h2>
        <div class="col-lg-8">
          <div class="card-dashboard">
            <div class="header-sales ">
              <div>
                <h4>{{ $t("dashboard.information.title") }}</h4>
                <div class="d-flex mt-4">
                  <img src="../../images/admin/icons/chuspic.png" class="img-icon margin-t-plan-logo" alt="">
                  <h4 class="title-plan">{{ $t("dashboard.information.type") }}</h4>
                  <div class="vertical-line ml-15"></div>
                  <p class="ml-15 margin-t-plan">{{ $t("dashboard.information.time") }}</p>
                </div>

              </div>

              <div class="d-flex">
                <a :href="`mailto:contacto@chuspic.com?subject=${$t('dashboard.information.credits')}`" target="_blank">
                  <button class="button-light-show">{{ $t("dashboard.information.buy") }}</button>
                </a>

              </div>
            </div>

            <div class="row header-plan-top" v-if="!loadingPlan">
              <div class="col-md-3 col-12 header-sales-top-icons-information">
                <p class="text-space-separate">{{ $t("dashboard.information.renew") }} </p>
                <p class="text-space-separate" v-if="partner && partner.plan">
                  {{ partner.plan.due_date | toReformatDay }} </p>
              </div>
              <div class="col-md-2 col-6 header-sales-top-icons-information">
                <img src="../../images/admin/icons/photo_camera.png" class="mb-3" alt="">
                <p class="text-space-separate text-strong" v-if="partner.photos">
                  {{ partner.photos.useds | toNumberFormat }}</p>
                <p class="text-space-separate">{{ $t("dashboard.information.used") }}</p>
              </div>
              <div class="col-md-2 col-6 header-sales-top-icons-information">
                <img src="../../images/admin/icons/photo_camera_white.png" class="mb-3" alt="">
                <p class="text-space-separate text-strong" v-if="partner.photos">
                  {{ partner.photos.availables | toNumberFormat }}</p>
                <p class="text-space-separate">{{ $t("dashboard.information.available") }}</p>
              </div>
              <div class="col-md-2 col-6 header-sales-top-icons-information">
                <img src="../../images/admin/icons/photo_library_blue.png" class="mb-3" alt="">
                <p class="text-space-separate text-strong" v-if="partner.photos">
                  {{ partner.photos.total | toNumberFormat }}</p>
                <p class="text-space-separate">{{ $t("dashboard.information.total") }}</p>
              </div>
              <div class="col-md-3 col-6 header-sales-top-icons-information">
                <img src="../../images/admin/icons/timelapse.png" class="mb-3" alt="">
                <p class="text-space-separate text-strong" v-if="partner.plan">
                  {{ partner.plan.remaining_days | toNumberFormat }}</p>
                <p class="text-space-separate">{{ $t("dashboard.information.remaining") }}</p>
              </div>
            </div>
            <div class="row header-plan-top" v-else>
              <LoaderSection :visible="loadingPlan"></LoaderSection>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="card-dashboard">
            <div class="header-sales">
              <div>
                <h4>{{ $t("dashboard.sales.title") }}</h4>
              </div>
              <a href="/admin/orders">
                <button class="button-light-show">{{ $t("dashboard.sales.view") }}</button>
              </a>
            </div>
            <LoaderSection :visible="loadingSales"></LoaderSection>
            <div class="row mt-4">
              <div class="col-md-6 col-12 header-sales-top">
                <label for="">{{ $t("dashboard.sales.start") }}</label>
                <input type="date" @change="filterDates" v-model="filters.initialDay" class="form-control input-form"/>
              </div>
              <div class="col-md-6 col-12 header-sales-top">
                <label for="">{{ $t("dashboard.sales.end") }}</label>
                <input type="date" @change="filterDates" v-model="filters.endDay" class="form-control input-form"/>
              </div>
              <div class="col-md-3 col-4 header-sales-top-icons">
                <img src="../../images/admin/icons/photo_camera.png" class="mb-3" alt="">
                <p class="text-space-separate text-strong" v-if="summaries">{{
                    summaries.total_orders | toNumberFormat
                  }}</p>
                <p class="text-space-separate">{{ $t("dashboard.sales.order") }}</p>
              </div>
              <div class="col-md-3 col-4 header-sales-top-icons">
                <img src="../../images/admin/icons/photo_library_blue.png" class="mb-3" alt="">
                <p class="text-space-separate text-strong" v-if="summaries">{{
                    summaries.total_events | toNumberFormat
                  }}</p>
                <p class="text-space-separate">{{ $t("dashboard.sales.events") }}</p>
              </div>
              <div class="col-md-3 col-4 header-sales-top-icons">
                <img src="../../images/admin/icons/monetization_on.png" class="mb-3" alt="">
                <p class="text-space-separate text-strong" v-if="summaries">
                  {{ summaries.total_amount | toCurrencyDecimals }}</p>
                <p class="text-space-separate">{{ $t("dashboard.sales.total") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-lg-8 mt-4">
          <div class="row">
            <div class="col-md-3 col-6">
              <div class="flex-space-between">
                <div class="icon-box">
                  <img src="../../images/admin/icons/photo_library.png" alt="">
                  <h5>{{ $t("dashboard.menu.events") }}</h5>
                  <ul class="list-links-dashboard">
                    <li>
                      <a class="link-dashboard" href="/admin/events">{{ $t("dashboard.menu.events") }}</a>
                    </li>
                    <li>
                      <a class="link-dashboard" href="/admin/events/new">{{ $t("dashboard.menu.newEvent") }}</a>
                    </li>
                    <li>
                      <a class="link-dashboard" href="/admin/groups">{{ $t("dashboard.menu.group") }}</a>
                    </li>
                  </ul>


                </div>
                <div class="vertical-line"></div>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="flex-space-between">
                <div class="icon-box">
                  <img src="../../images/admin/icons/web.png" alt="">
                  <h5>{{ $t("dashboard.menu.site") }}</h5>
                  <ul class="list-links-dashboard">
                    <li>
                      <a href="/admin/preferences" class="link-dashboard">{{ $t("dashboard.menu.viewWeb") }}
                      </a>
                    </li>
                    <li>
                      <a class="link-dashboard" href="/admin/users">{{ $t("dashboard.menu.users") }}</a>
                    </li>
                  </ul>
                </div>
                <div class="vertical-line"></div>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="flex-space-between">
                <div class="icon-box">
                  <img src="../../images/admin/icons/store_mall_directory.png" alt="">
                  <h5>{{ $t("dashboard.menu.store") }}</h5>
                  <ul class="list-links-dashboard">
                    <li>
                      <a class="link-dashboard" href="/admin/orders">{{ $t("dashboard.menu.orders") }}</a>
                    </li>
                    <li>
                      <a class="link-dashboard" href="/admin/concepts">{{ $t("dashboard.menu.products") }}</a>
                    </li>
                  </ul>
                </div>
                <div class="vertical-line"></div>
              </div>
            </div>
            <div class="col-md-3 col-6">
              <div class="flex-space-between">
                <div class="icon-box">
                  <img src="../../images/admin/icons/person.png" alt="">
                  <h5>{{ $t("dashboard.menu.account") }}</h5>
                  <ul class="list-links-dashboard">
                    <li>
                      <router-link :to="{name: 'Profile'}" class="link-dashboard">{{ $t("dashboard.menu.profile") }}
                      </router-link>
                    </li>
                    <li>
                      <a class="link-dashboard" href="/admin/preferences">{{ $t("dashboard.menu.plan") }}</a>
                    </li>
                    <li>
                      <a class="link-dashboard" href="/admin/descriptions">{{ $t("dashboard.menu.legal") }}</a>
                    </li>
                  </ul>
                </div>
                <div class="vertical-line-final"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 mt-4">
          <div class="card-new-event">
            <div class="d-flex mb-4 justify-content-center-custom">
              <img src="../../images/admin/icons/plus_add.png" alt="">
            </div>
            <div class="d-flex mb-4 justify-content-center-custom">
              <h3 class="text-white-custom">{{ $t("dashboard.create") }}</h3>
            </div>
            <div class="d-flex justify-content-center-custom">
              <a href="/admin/events/new">
                <button class="button-white-admin">{{ $t("dashboard.begin") }}</button>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4 mt-5">
        <div class="col-lg-12" v-if="eventsRecent.length > 0">
          <h3 class="mb-4">{{ $t("dashboard.recent") }}</h3>
          <div class="row mt-4">
            <div v-for="event in eventsRecent" :key="event.id" class="col-md-3">
              <div class="mb-4 relative-custom">
                <a :href="event.external_url" v-if="event.external">
                  <img :src="event.logo_url" class="full-width-custom" :alt="event.name"/>
                </a>
                <router-link v-if="!event.external" :to="{name: 'ShowEvent', params: {id: event.identifier.toString()}}">
                  <img :src="event.logo_url" class="card-img-top" alt="event.name">
                </router-link>
                <div class="icon-position-card">
                  <div class="flex-space-between">
                    <div class="d-flex">
                      <div v-if="event.locked" class="icon-back">
                        <i class="fas fa-lock"></i>
                      </div>
                      <div v-if="event.visible" class="icon-back">
                        <i class="fas fa-eye"></i>
                      </div>
                    </div>
                    <div>
                      <div class="icon-back-menu cursor-pointer relative-custom" @mouseenter="showMenu(event.id, true)"
                      >
                        <i class="fas fa-ellipsis-v"></i>
                        <div v-if="isMenuEventRecent === event.id" class="menu-pay" @mouseleave="hideMenu(true)">
                          <a class="text-black-custom"
                             :href="`/admin/orders?utf8=✓&q[order_details_event_id_eq]=${event.identifier}&q[status_eq]=paid`">
                            {{ $t("dashboard.menu.orders") }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div v-if="event.external">
                  <a :href="event.external_url">
                    <h3 class="mb-4 size-22-custom text-black-custom">{{ event.name }}</h3>
                  </a>
                </div>
                <div v-if="!event.external">
                  <router-link :to="{name: 'AsdEvent', params: {id: event.identifier.toString()}}">
                    <h3 class="mb-4 size-22-custom text-black-custom">{{ event.name }}</h3>
                  </router-link>
                </div>
                <div class="flex-space-between">
                  <p>{{ event.event_at | toLongDate }}</p>
                  <div :class="getEventProperties(event.state).className">
                    <p>{{ getEventProperties(event.state).text }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col-lg-12" v-if="eventsUpcoming.length > 0">
          <h3 class="mb-4">{{ $t("dashboard.next") }}</h3>
          <div class="row mt-4">
            <div v-for="event in eventsUpcoming" :key="event.id" class="col-md-3">
              <div class="mb-4 relative-custom">
                <a :href="event.external_url" v-if="event.external">
                  <img :src="event.logo_url" class="full-width-custom" :alt="event.name"/>
                </a>
                <router-link v-if="!event.external" :to="{name: 'ShowEvent', params: {id: event.identifier.toString()}}">
                  <img :src="event.logo_url" class="card-img-top" alt="event.name">
                </router-link>
                <div class="icon-position-card">
                  <div class="flex-space-between">
                    <div class="d-flex">
                      <div v-if="event.locked" class="icon-back">
                        <i class="fas fa-lock"></i>
                      </div>
                      <div v-if="event.visible" class="icon-back">
                        <i class="fas fa-eye"></i>
                      </div>
                    </div>
                    <div>
                      <div class="icon-back-menu cursor-pointer relative-custom" @mouseenter="showMenu(event.id, false)"
                      >
                        <i class="fas fa-ellipsis-v"></i>
                        <div v-if="isMenuEventUpcoming === event.id" class="menu-pay" @mouseleave="hideMenu(false)">
                          <a class="text-black-custom"
                             :href="`/admin/orders?utf8=✓&q[order_details_event_id_eq]=${event.identifier}&q[status_eq]=paid`">
                            {{ $t("dashboard.menu.orders") }}
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div v-if="event.external">
                  <a :href="event.external_url">
                    <h3 class="mb-4 size-22-custom text-black-custom">{{ event.name }}</h3>
                  </a>
                </div>
                <div v-if="!event.external">
                  <router-link :to="{name: 'AsdEvent', params: {id: event.identifier.toString()}}">
                    <h3 class="mb-4 size-22-custom text-black-custom">{{ event.name }}</h3>
                  </router-link>
                </div>
                <div class="flex-space-between">
                  <p>{{ event.event_at | toLongDate }}</p>
                  <div :class="getEventProperties(event.state).className">
                    <p>{{ getEventProperties(event.state).text }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div v-if="partner.analytics_url" class="row mb-4">
        <hr />
        <iframe 
          :src="partner.analytics_url"
          width="100%"
          height="2000"
          frameborder="0"
          style="border:0"
          allowfullscreen
          sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
        >
        </iframe>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import Partner from "../../models/Partner";
import Loader from "../../components/Loader.vue";
import LoaderSection from "../../components/LoaderSection";
import EventList from "../../models/EventList";
import Sales from "../../models/Sales";

export default {
  name: "AdminDashboard",
  components: {
    Loader,
    LoaderSection
  },
  data() {
    return {
      loading: false,
      loadingSales: true,
      eventsRecent: [],
      eventsUpcoming: [],
      isMenuEventRecent: null,
      isMenuEventUpcoming: null,
      eventList: new EventList(),
      loadingPlan: false,
      partner: new Partner(),
      sales: new Sales(),
      summaries: null,
      filters: {
        initialDay: null,
        endDay: null,
      }
    }
  },
  mounted() {
    this.getSummary();
    this.getDataAccount();
  },
  async created() {
    await this.getRecentEvents();
    await this.getUpcomingEvents();
  },
  methods: {
    showMenu(position, recent) {
      if (recent) {
        this.isMenuEventRecent = position;
        return;
      }
      this.isMenuEventUpcoming = position;
    },
    hideMenu(recent) {
      if (recent) {
        this.isMenuEventRecent = null;
        return;
      }
      this.isMenuEventUpcoming = null;
    },
    async getDataAccount() {
      this.loadingPlan = true;
      this.partner = this.currentPreference;
      this.loadingPlan = false;
    },
    async getSummary() {
      this.loadingSales = true;
      this.summaries = await this.sales.summary(this.queryParams);
      this.loadingSales = false;
    },
    async filterDates() {
      if (!this.filters.initialDay || !this.filters.endDay) return;
      await this.getSummary();
    },
    async getRecentEvents() {
      this.eventsRecent = await this.eventList.recents({limit: 4, display_all: true});
    },
    async getUpcomingEvents() {
      this.eventsUpcoming = await this.eventList.upcoming({limit: 4, display_all: true});
    },
    getEventProperties(eventStatus) {
      switch (eventStatus) {
        case 'released':
          return {className: 'badge-released-cards', text: this.$t("dashboard.released")};
        case 'pending':
          return {className: 'badge-pending-cards', text: this.$t("dashboard.pending")};
        case 'cancelled':
          return {className: 'badge-cancelled-cards', text: this.$t("dashboard.cancel")};
        default:
          return {className: '', text: ''};
      }
    }
  },
  computed: {
    ...mapGetters('Preference', ['currentPreference']),
    queryParams() {
      return {
        "q[created_at_gteq]": this.filters.initialDay,
        "q[created_at_lteq]": this.filters.endDay,
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/admin/main';

.icon-box {
  margin-bottom: 30px;
}

.icon-box img {
  font-size: 15px;
  margin-bottom: 10px;
  background-color: #CCF6FF;
  padding: 7px;
  border-radius: 10px;
}

.vertical-line {
  border-left: 2px solid #dee2e6;
}

.img-icon {
  width: 24px;
  height: 24px;
}

.title-plan {
  margin-left: 10px;
  font-weight: 700
}

.text-space-separate {
  margin-bottom: 0px !important;
}

a {
  text-decoration: none !important;
}

.link-dashboard {
  color: black;
  cursor: pointer;
}

.list-links-dashboard {
  list-style-type: none !important;
  padding-left: 0 !important;
}

.icon-back {
  background-color: #F1F1F5;
  margin-left: 10px;
  text-align: center;
  border-radius: 8px;
  display: inline-block;
  width: 28px;
  height: 28px;
  font-size: 17px;
  line-height: 30px;
  color: #31343E;
}

.icon-back-menu {
  background-color: #F1F1F5;
  margin-right: 10px;
  text-align: center;
  border-radius: 8px;
  display: inline-block;
  width: 28px;
  height: 28px;
  font-size: 17px;
  line-height: 30px;
  color: #31343E;
}

.list-links-dashboard li {
  margin-top: 10px !important;
}

.menu-pay {
  padding: 10px;
  position: absolute;
  background-color: #fff;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2);
  z-index: 100;
  color: black;
}
</style>
